export default __webpack_public_path__ + "aae43ca1cc24878202ae0cf0597bdbf5.png";